import React from "react";
import "./loading.scss";

export default function Loading() {
  return (
    <div className="space-loading">
      {/* Star layers */}
      <div className="stars stars-sm" />
      <div className="stars stars-md" />
      <div className="stars stars-lg" />

      {/* Nebula glow blobs */}
      <div className="nebula nebula-1" />
      <div className="nebula nebula-2" />

      {/* Central planet system */}
      <div className="planet-system">
        {/* Outer orbit ring */}
        <div className="orbit orbit-outer">
          <div className="satellite satellite-outer" />
        </div>

        {/* Inner orbit ring */}
        <div className="orbit orbit-inner">
          <div className="satellite satellite-inner" />
        </div>

        {/* The planet */}
        <div className="planet">
          <div className="planet-band band-1" />
          <div className="planet-band band-2" />
          <div className="planet-band band-3" />
          <div className="planet-shine" />
          <div className="planet-atmosphere" />
        </div>
      </div>

      {/* Loading text */}
      <div className="loading-text-wrap">
        <p className="loading-label">Initializing</p>
        <div className="loading-dots">
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}
